import { Empty } from "antd";
import classNames from "classnames";
import styles from "./index.module.less";

export default function HBEmpty({ title, subtitle, size, ...props }) {
  return (
    <Empty
      imageStyle={{
        height: 166,
      }}
      description={
        <div
          className={classNames([
            styles.description,
            size === "small" ? styles.small : null,
          ])}
        >
          <div className={styles.title}>{title}</div>
          <div className={styles.subtitle}>{subtitle}</div>
        </div>
      }
      {...props}
    />
  );
}
